module.exports = __webpack_public_path__ + "img/kg4002_center_001.7b308db4.png";